<template>
  <select :disabled="disabled">
    <slot></slot>
  </select>
</template>
<script>
export default {
  name: 'Select2',
  props: ['options', 'value', 'disabled', 'change'],
  template: '#select2-template',
  mounted: function () {
    var vm = this
    window.$(this.$el)
      // init select2
      .select2({ data: this.options, theme: 'bootstrap', disabled: this.disabled })
      .val(this.value)
      .trigger('change')
      // emit event on change.
      .on('change', function () {
        vm.$emit('input', this.value)

        if (this.change) {
          this.change(this.value)
        }
      })
  },
  watch: {
    value: function (value) {
      // update value
      window.$(this.$el)
        .val(value)
        .trigger('change')
    },
    options: function (options) {
      // update options
      window.$(this.$el).empty().select2({ data: options, theme: 'bootstrap' })
    }
  },
  destroyed: function () {
    window.$(this.$el).off().select2('destroy')
  }
}
</script>
<style lang="scss">
.select2-container {
  width: 100% !important;
  margin-bottom: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/utils/Select2.vue